import { makeStyles } from 'tss-react/mui';
const useStyles = makeStyles()((theme) => ({
    richText: {
        '& h1, & h2, & h3, & h4': Object.assign(Object.assign({ textAlign: theme.isFlyingFlowers ? 'center' : undefined }, theme.typography.medium_bold), theme.typographySpacing.medium_bold_lg),
        '& p': Object.assign(Object.assign({ textAlign: theme.isFlyingFlowers ? 'center' : undefined }, theme.typography.small_regular), theme.typographySpacing.small_regular_sm),
        '& li p': { textAlign: theme.isFlyingFlowers ? 'left' : undefined },
    },
}));
export default useStyles;
